export { DEFAULT_LANG, availableLocales } from 'sn-front-webpack-config/locales';
